import { Tag } from "@chakra-ui/react";

interface TagStatusProps {
  icon?: React.ReactNode;
  title: string;
  colorScheme: string;
}

export default function TagStatus({
  colorScheme,
  title,
  icon,
}: TagStatusProps) {
  return (
    <Tag
      rounded={15}
      px={4}
      py={1}
      gap={2.5}
      border={`solid 2px ${colorScheme}`}
      size="xs"
      fontSize="14px"
      fontWeight="medium"
      bg="white"
      color={colorScheme}
    >
      {icon}
      {title}
    </Tag>
  );
}
